import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// react-snap serializes the live DOM, so JSX like `{count} Installations`
// (two text nodes) would be saved as one and break hydration. Separate
// adjacent text nodes with empty comments, as React's own SSR does.
window.snapSaveState = () => {
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
  const splitPoints = [];
  while (walker.nextNode()) {
    if (walker.currentNode.nextSibling?.nodeType === Node.TEXT_NODE) {
      splitPoints.push(walker.currentNode);
    }
  }
  splitPoints.forEach((node) => node.after(document.createComment("")));
  // Radix Select fills its hidden native <select> after mount; the first
  // client render has it empty.
  container.querySelectorAll('select[aria-hidden="true"]').forEach((select) => { select.innerHTML = ""; });
  return {};
};
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
